// Flow types automatically removed

import { Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import getter from 'dibs-object-getter';
import { InteriorsLandingModuleHeader } from './InteriorsLandingModuleHeader.jsx';
import { InteriorsLandingProjectItem } from './InteriorsLandingProjectItem.jsx';
function InteriorsLandingProjectsComponent({ projectsModule }) {
    const showPrimaryProjects = getter(projectsModule)
        .at('primaryProjectsModule')
        .value('isVisible');
    const primaryProjects = (
        getter(projectsModule).at('primaryProjectsModule').value('items') || []
    ).filter(Boolean);
    const showSecondaryProjects = getter(projectsModule)
        .at('secondaryProjectsModule')
        .value('isVisible');
    const secondaryProjects = (
        getter(projectsModule).at('secondaryProjectsModule').value('items') || []
    ).filter(Boolean);
    const showTertiaryProjects = getter(projectsModule)
        .at('tertiaryProjectsModule')
        .value('isVisible');
    const tertiaryProjects = (
        getter(projectsModule).at('tertiaryProjectsModule').value('items') || []
    ).filter(Boolean);
    return (
        <Fragment>
            <InteriorsLandingModuleHeader
                header={getter(projectsModule).value('projectsHeadModule') || {}}
                module="projects"
            />
            {showPrimaryProjects && (
                <div className="rowFlex" data-tn="interiors-landing-primary-projects-row">
                    {primaryProjects.map((item, index) => (
                        <InteriorsLandingProjectItem
                            projectModule={item}
                            type="primary"
                            key={`project-primary-${index}`}
                        />
                    ))}
                </div>
            )}
            {showSecondaryProjects && (
                <div className="rowFlex" data-tn="interiors-landing-secondary-projects-row">
                    {secondaryProjects.map((item, index) => (
                        <InteriorsLandingProjectItem
                            projectModule={item}
                            type="secondary"
                            key={`project-secondary-${index}`}
                        />
                    ))}
                </div>
            )}
            {showTertiaryProjects && (
                <div className="rowFlex" data-tn="interiors-landing-tertiary-projects-row">
                    {tertiaryProjects.map((item, index) => (
                        <InteriorsLandingProjectItem
                            projectModule={item}
                            type="tertiary"
                            key={`project-tertiary-${index}`}
                        />
                    ))}
                </div>
            )}
        </Fragment>
    );
}
export const InteriorsLandingProjects = createFragmentContainer(InteriorsLandingProjectsComponent, {
    projectsModule: graphql`
        fragment InteriorsLandingProjects_projectsModule on InteriorsLandingPage {
            projectsHeadModule {
                ...InteriorsLandingModuleHeader_header
            }
            primaryProjectsModule {
                isVisible
                items {
                    ...InteriorsLandingProjectItem_projectModule
                }
            }
            secondaryProjectsModule {
                isVisible
                items {
                    ...InteriorsLandingProjectItem_projectModule
                }
            }
            tertiaryProjectsModule {
                isVisible
                items {
                    ...InteriorsLandingProjectItem_projectModule
                }
            }
        }
    `,
});
